import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-marco-legal',
  templateUrl: './marco-legal.component.html',
  styleUrls: ['./marco-legal.component.css']
})
export class MarcoLegalComponent {

  @Input() fields;

}
